import createReducer from '../createReducer';
import {TTimetable} from './timetable.type';

const initialState: TTimetable = {
    lectures: {},
    currentDayIndex: 0,
    getLecturesXHR: null,
    getLecturersXHR: null,
    moveLectureXHR: null,
    deleteLectureXHR: null,
    duplicateLectureXHR: null,
    createLecturerXHR: null,
    saveLecturerXHR: null,
    lecturers: [],
    halls: [],
    slots: [],
};

const reducer = createReducer('timetable', initialState);

export default reducer;
